import {connect} from 'react-redux';
import {
  getCardCount,
  getGroupSettings,
  getSortedOpportunityCardsSelector,
} from 'shared/micro-scholarships/selectors';
import {LOADING_IDENTIFIER} from '../actions/opportunity-cards';
import OpportunityCards from '../components/opportunity-cards';

export const mapStateToProps = (state) => {
  const {microscholarshipsLoading} = state;
  const settings = getGroupSettings();
  return {
    cardGroupings: settings.cardGroupings,
    cardGroupingOrder: settings.cardGroupingOrder,
    loading: microscholarshipsLoading[LOADING_IDENTIFIER] !== false,
    cards: getSortedOpportunityCardsSelector(state),
    cardCount: getCardCount(state),
  };
};

export default connect(mapStateToProps)(OpportunityCards);
